import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-057e81f4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "sub-title"
};
const _hoisted_5 = {
  class: "platform"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "show-img"
}, null, -1));
const _hoisted_7 = {
  class: "info"
};
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import softwareData from '@/data/software';
import ChatUs from '@/components/chat-us';
export default /*#__PURE__*/_defineComponent({
  __name: 'detail',
  setup(__props) {
    const router = useRouter();
    const $route = useRoute();
    const id = $route.params.id;
    const currentData = ref({});
    const keys = Object.keys(softwareData);
    // 防止id被篡改导致页面数据出错
    if (!keys.includes(id)) {
      router.replace('/software');
    } else {
      currentData.value = softwareData[id];
    }
    const visible = ref(false);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h3", _hoisted_3, _toDisplayString(currentData.value.title), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(currentData.value.subTitle), 1)])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("p", null, _toDisplayString(currentData.value.desc), 1), _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = $event => visible.value = true),
        class: "btn"
      }, "申请试用")])]), _createVNode(_unref(ChatUs), {
        visible: visible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = $event => visible.value = $event)
      }, null, 8, ["visible"])], 64);
    };
  }
});